import { useContext, useEffect, useRef, useState } from 'react';
import Page from '../../../layout/Page/Page';
import { toasts } from '../../../services/toast.service';
import Button, { ButtonGroup } from '../../bootstrap/Button';
import Card, {
	CardHeader,
	CardLabel,
	CardTitle,
	CardBody,
	CardActions,
} from '../../bootstrap/Card';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Select from '../../bootstrap/forms/Select';
import Collapse from '../../bootstrap/Collapse';
import Icon from '../../icon/Icon';
import useSortableData from '../../../hooks/useSortableData';
import PaginationButtons, { dataPagination } from '../../PaginationButtons';
import { useReactToPrint } from 'react-to-print';
import Dropdown, { DropdownToggle, DropdownMenu, DropdownItem } from '../../bootstrap/Dropdown';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Input from '../../bootstrap/forms/Input';
import { useFormik } from 'formik';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import OpenCardComponent from '../../../common/components/OpenCardComponent';
import { convertJsonToPdf, downloadExcel, downloadFile } from '../../../services/ExportService';
import { getStudentScholarshipReport } from '../../../services/report.service';
import AuthContext from '../../../contexts/authContext';
import {
	getColumnsForDataTable,
	getGraduationType,
	updateColumnsForDataTable,
	updateFilter,
} from '../../../services/common.service';
import { getLicenseKey } from '../../../services/application.settings';
import { getScholarshipType } from '../../../services/scholarship.service';
import { getBatchByCourseId, getCourse, getDepartmentList } from '../../../services/master.service';
import NoDataMsg from '../../../common/components/NoDataMsg';
import SearchableSelect from '../../../common/components/SearchableSelect';

function StudentScholarshipReport() {
	useEffect(() => {
		getGraduationList();
		getDepartment();
		getScholarship();
	}, []);

	const { userAccountId, userTypeId } = useContext(AuthContext);
	const [departmentId, setDepartmentId] = useState<any>('');
	const [courseId, setCourseId] = useState<any>('');
	const [batchMasterId, setBatchMasterId] = useState<any>('');
	const [graduationTypeId, setGraduationTypeId] = useState<any>('');
	const [scholarshipTypeId, setScholarshipTypeId] = useState<any>('');
	const [departmentData, setDepartmentData] = useState<any>([]);
	const [courseData, setCourseData] = useState<any>([]);
	const [graduationTypeData, setGraduationTypeData] = useState<any>([]);
	const [batchMasterData, setBatchMasterData] = useState<any>([]);
	const [scholarshipTypeData, setScholarshipTypeData] = useState<any>([]);
	const [studentScholarshipReportData, setStudentScholarshipReportData] = useState([]);
	const [dataSuccess, setDataSuccess] = useState(false);

	const [isOpenListCard, setIsOpenListCard] = useState(true);
	const [columnVisibilityData, setColumnVisibilityData] = useState([]);
	const [allColumnsData, setAllColumnsData] = useState([]);
	const [columnVisibilityMenu, setColumnVisibilityMenu] = useState(false);
	const [columnDataById, setColumnDataById] = useState([]);
	const componentRef = useRef(null);
	const [isChecked, setIsChecked] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const { items, requestSort, getClassNamesFor } = useSortableData(studentScholarshipReportData);
	const onCurrentPageData = dataPagination(items, currentPage, perPage);
	const [isLoader, setIsLoader] = useState(false);

	const [noDataMsg, setNoDataMsg] = useState('');

	const columnVisibilityForm = useFormik({
		enableReinitialize: true,
		initialValues: {
			searchInput: '',
			available: false,
		},
		validate: (values) => { },

		//validateOnChange: false,
		onSubmit: () => { },
	});

	// Filter
	const filteredData = updateFilter(
		onCurrentPageData,
		columnVisibilityData,
		columnVisibilityForm,
	);

	function view() {
		setDataSuccess(false);
		setIsLoader(true);
		getStudentScholarship(batchMasterId?.value, scholarshipTypeId?.value);
		columnVisibilityForm.resetForm();
	}

	const selectDepartment = (e: any) => {
		setGraduationTypeId('');
		setCourseId('');
		setBatchMasterId('');
		setScholarshipTypeId('');
		let departmentId = e;
		setDepartmentId(departmentId);
	};

	const selectGraduationType = (e: any) => {
		setCourseId('');
		setBatchMasterId('');
		setScholarshipTypeId('');
		let graduationTypeId = e;
		setGraduationTypeId(graduationTypeId);
		getCourseList(departmentId?.value, graduationTypeId?.value);
	};

	const selectCourse = (e: any) => {
		setBatchMasterId('');
		setScholarshipTypeId('');
		let courseId = e;
		setCourseId(courseId);
		getBatchList(courseId?.value, graduationTypeId?.value);
	};

	const selectBatch = (e: any) => {
		setScholarshipTypeId('');
		let batchMasterId = e;
		setBatchMasterId(batchMasterId);
	};

	const selectScholarship = (e: any) => {
		let scholarshipTypeId = e;
		setScholarshipTypeId(scholarshipTypeId);
	};

	function getDepartment() {
		getDepartmentList(
			(response) => {
				if (response.data.success) {
					let data = response.data.data.department;
					if (data != undefined) {
						setDepartmentData(data);
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					//toasts(response.data.message, "Error")
					setDepartmentData([]);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function getGraduationList() {
		getGraduationType(
			(response) => {
				if (response.data.success) {
					let data = response.data.data.graduationType;
					if (data != undefined) {
						setGraduationTypeData(data);
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					//toasts(response.data.message, "Error")
					setGraduationTypeData([]);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function getCourseList(departmentId: any, graduationTypeId: any) {
		getCourse(
			departmentId,
			graduationTypeId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.course;
					if (data != undefined) {
						setCourseData(data);
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					//toasts(response.data.message, "Error")
					setCourseData([]);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function getBatchList(courseId: any, graduationTypeId: any) {
		getBatchByCourseId(
			courseId,
			graduationTypeId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.batchByCourseId;
					if (data != undefined) {
						setBatchMasterData(data);
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					//toasts(response.data.message, "Error")
					setBatchMasterData([]);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function getScholarship() {
		getScholarshipType(
			(response) => {
				if (response.data.success) {
					let data = response.data.data.scholarshipType;
					if (data != undefined) {
						const scholarshipTypeData = [
							{ scholarshipTypeId: 0, scholarshipType: 'All Scholarship' },
						];
						data.forEach(
							(obj: { scholarshipTypeId: number; scholarshipType: string }) => {
								let scholarshipType = scholarshipTypeData.push(obj);
							},
						);

						setScholarshipTypeData(scholarshipTypeData);
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					//toasts(response.data.message, "Error")
					setScholarshipTypeData([]);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function getStudentScholarship(batchMasterId: string, scholarshipTypeId: string) {
		setIsLoader(true);
		getStudentScholarshipReport(
			batchMasterId,
			scholarshipTypeId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.studentScholarshipReport;
					if (data != undefined) {
						setIsLoader(false);
						setStudentScholarshipReportData(data);
						setIsOpenListCard(false);
						setDataSuccess(true);
						getColumnsForTable('getStudentScholarshipReport', 'get');
						for (let i = 0; i < data.length; i++) {
							data[i].sno = i + 1;
						}
					} else {
						setIsLoader(false);
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					setIsLoader(false);
					//toasts(response.data.message, "Error")
					getColumnsForTable('getStudentScholarshipReport', 'get');
					setStudentScholarshipReportData([]);
					setNoDataMsg(response.data.message);
					setIsOpenListCard(false);
					setDataSuccess(true);
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					setIsLoader(false);
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				setIsLoader(false);
				toasts(error, 'Error');
			},
		);
	}

	function getColumnsForTable(apiName: any, type: any) {
		getColumnsForDataTable(
			userTypeId,
			apiName,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.columnsForDataTable;
					if (data != undefined) {
						let allColumnsData = data;
						setAllColumnsData(allColumnsData);
						let columnVisibilityData = allColumnsData.filter(
							(item: any) => item.isDisplay == 1,
						);
						setColumnVisibilityData(columnVisibilityData);

						if (type == 'get') {
							const allData = allColumnsData.map((item: any) => item.isDisplay);
							const allColumns = allData.filter((item: any) => item == false);
							setIsChecked(allColumns == '' ? true : false);
						} else if (type == 'post') {
							const all = [];
							let nonDefaultValue = allColumnsData.filter(
								(item: any) => item.isDefault == false,
							);

							for (let i = 0; i < nonDefaultValue.length; i++) {
								const obj = {
									columnVisibilityId: nonDefaultValue[i].columnVisibilityId,
									isDisplay: nonDefaultValue[0].isDisplay == 0 ? 1 : 0,
								};
								all.push(obj);
							}
							updateColumnsSubmit('', '', all);
						}
					} else {
						toasts('Undefined Data', 'Error');
					}
				} else if (response.data.success === false) {
					toasts(response.data.message, 'Error');
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, 'Error');
				}
			},
			(error) => {
				toasts(error, 'Error');
			},
		);
	}

	function updateColumnsSubmit(columnVisibilityId: any, isDisplay: any, type: any) {
		if (columnVisibilityForm.isValid) {
			setColumnDataById(isDisplay);
			const columnVisibilityPostData = {
				licenseKey: getLicenseKey,
				userAccountId: userAccountId,
				columns: type
					? type
					: [
						{
							columnVisibilityId: columnVisibilityId,
							isDisplay: isDisplay ? 0 : 1,
						},
					],
			};

			updateColumnsForDataTable(
				columnVisibilityPostData,
				(response) => {
					const data = response.data;
					if (data.success == true) {
						getColumnsForTable('getStudentScholarshipReport', 'get');
					} else if (data.success == false) {
						// toasts(data.success, "Error")
					} else {
						let errorCode = response.data.error[0].error_code;
						let errorDescription = response.data.error[0].error_description;
						toasts(errorDescription, 'Error');
					}
				},
				(error) => {
					toasts(error, 'Error');
				},
			);
		} else if (columnVisibilityForm.isValid == false) {
			toasts('Please fill all the details!', 'Error');
		}
	}

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	return (
		<PageWrapper title='Student Scholarship Report'>
			<Page container='fluid'>
				<Collapse isOpen={isOpenListCard}>
					<Card stretch data-tour='list'>
						<CardHeader borderSize={1}>
							<CardLabel iconColor='info'>
								<CardTitle tag='div' className='h5'>
									Student Scholarship Report
								</CardTitle>
							</CardLabel>
						</CardHeader>
						<CardBody>
							<div className='row'>
								<div className='col-3'>
									<FormGroup id='departmentId' label='Department' isFloating>
										<SearchableSelect
											isFloating
											ariaLabel='Department'
											onChange={selectDepartment}
											value={departmentId}
											list={departmentData.map((data: any) => ({
												value: data.departmentId,
												label: data.departmentName,
											}))}
										/>
									</FormGroup>
								</div>
								{departmentId?.value ? (
									<div className='col-3'>
										<FormGroup
											id='graduationTypeId'
											label='Graduation Type'
											isFloating>
											<SearchableSelect
												isFloating
												ariaLabel='Graduation Type'
												onChange={selectGraduationType}
												value={graduationTypeId}
												list={graduationTypeData.map((data: any) => ({
													value: data.graduationTypeId,
													label: data.graduationType,
												}))}
											/>
										</FormGroup>
									</div>
								) : null}

								{graduationTypeId?.value ? (
									<div className='col-3'>
										<FormGroup id='courseId' label='Course' isFloating>
											<SearchableSelect
												isFloating
												ariaLabel='Course'
												onChange={selectCourse}
												value={courseId}
												list={courseData.map((data: any) => ({
													value: data.courseId,
													label: data.courseName,
												}))}
											/>
										</FormGroup>
									</div>
								) : null}

								{courseId?.value ? (
									<div className='col-3'>
										<FormGroup id='batchMasterId' label='Batch' isFloating>
											<SearchableSelect
												isFloating
												ariaLabel='Batch'
												onChange={selectBatch}
												value={batchMasterId}
												list={batchMasterData.map((data: any) => ({
													value: data.batchMasterId,
													label: data.batchName,
												}))}
											/>
										</FormGroup>
									</div>
								) : null}

								{batchMasterId?.value ? (
									<div className='col-3 mt-3'>
										<FormGroup
											id='scholarshipType'
											label='Scholarship Type'
											isFloating>
											<SearchableSelect
												isFloating
												ariaLabel='Scholarship Type'
												onChange={selectScholarship}
												value={scholarshipTypeId}
												list={scholarshipTypeData.map((data: any) => ({
													value: data.scholarshipTypeId,
													label: data.scholarshipType,
												}))}
											/>
										</FormGroup>
									</div>
								) : null}

								{scholarshipTypeId ? (
									<div className='col-3 mt-4'>
										<Button icon='ArrowDownward' color='primary' onClick={view}>
											View
										</Button>
									</div>
								) : null}
							</div>
						</CardBody>
					</Card>
				</Collapse>

				<OpenCardComponent
					isOpenListCard={isOpenListCard}
					setIsOpenListCard={setIsOpenListCard}
					isLoader={isLoader}
				/>

				{dataSuccess ? (
					<Card stretch data-tour='list' ref={componentRef} id='pdf'>
						<CardHeader borderSize={1}>
							<CardLabel icon='List' iconColor='info' className='col-lg-6'>
								<CardTitle tag='div' className='h5'>
									Student Scholarship List
								</CardTitle>
							</CardLabel>
							&nbsp;&nbsp;
							<ButtonGroup
								className='col-lg-3 justify-content-end d-print-none'
								color='primary'>
								<Icon className='mt-1' icon='Search' size='2x' color='primary' />
								<Input
									id='searchInput'
									type='search'
									placeholder='Search...'
									onChange={columnVisibilityForm.handleChange}
									value={columnVisibilityForm.values.searchInput}
								/>
							</ButtonGroup>
							<CardActions className='d-print-none'>
								<Dropdown
									isOpen={columnVisibilityMenu}
									setIsOpen={setColumnVisibilityMenu}
									isButtonGroup>
									<DropdownToggle>
										<Button icon='FilterAlt' color='primary' isLight>
											Filter
										</Button>
									</DropdownToggle>
									<DropdownMenu
										isAlignmentEnd
										size='lg'
										isCloseAfterLeave={false}>
										<DropdownItem>
											<div className='container py-2'>
												<form className='row g-3'>
													<div className='col-12'>
														<FormGroup>
															<h6>Select All</h6>
															<Checks
																id='available'
																type='switch'
																label='Select All Columns'
																onChange={() =>
																	getColumnsForTable(
																		'getStudentScholarshipReport',
																		'post',
																	)
																}
																checked={isChecked}
																ariaLabel='Available status'
															/>
														</FormGroup>
													</div>
													<div
														className='col-12'
														style={{
															maxHeight: '200px',
															overflowY: 'scroll',
														}}>
														<FormGroup>
															<h6>Columns</h6>
															<ChecksGroup>
																{allColumnsData.map((i: any) => (
																	<Checks
																		key={i.columnVisibilityId}
																		id='{i.columnVisibilityId}'
																		label={i.columnName}
																		onChange={() =>
																			updateColumnsSubmit(
																				i.columnVisibilityId,
																				i.isDisplay,
																				'',
																			)
																		}
																		checked={i.isDisplay}
																		disabled={
																			i.isDefault == true
																		}
																	/>
																))}
															</ChecksGroup>
														</FormGroup>
													</div>
												</form>
											</div>
										</DropdownItem>
									</DropdownMenu>
								</Dropdown>
								<Dropdown isButtonGroup>
									<DropdownToggle>
										<Button color='primary' isLight icon='CloudDownload'>
											{' '}
											Export{' '}
										</Button>
									</DropdownToggle>
									<DropdownMenu isAlignmentEnd>
										<DropdownItem>
											<Button
												color='primary'
												isLight
												icon='CloudDownload'
												onClick={() =>
													downloadExcel(
														'StudentScholarshipReport',
														studentScholarshipReportData,
														columnVisibilityData,
													)
												}>
												{' '}
												Excel{' '}
											</Button>
										</DropdownItem>
										<DropdownItem>
											<Button
												color='primary'
												isLight
												icon='PictureAsPdf'
												onClick={() =>
													convertJsonToPdf(
														studentScholarshipReportData,
														columnVisibilityData,
														'StudentScholarshipReport',
													)
												}>
												{' '}
												PDF
											</Button>
										</DropdownItem>
										<DropdownItem>
											<Button
												color='primary'
												isLight
												icon='CloudDownload'
												onClick={() =>
													downloadFile(
														'StudentScholarshipReport',
														studentScholarshipReportData,
														columnVisibilityData,
													)
												}>
												{' '}
												CSV{' '}
											</Button>
										</DropdownItem>
										<DropdownItem>
											<Button
												color='primary'
												isLight
												icon='Print'
												onClick={handlePrint}>
												{' '}
												Print{' '}
											</Button>
										</DropdownItem>
									</DropdownMenu>
								</Dropdown>
							</CardActions>
						</CardHeader>
						<CardBody className='table-responsive' isScrollable>
							<table className='table table-modern table-hover text-nowrap'>
								<thead>
									<tr>
										<th
											scope='col'
											onClick={() => requestSort('sno')}
											className='cursor-pointer text-decoration-underline'>
											S.No{' '}
											<Icon
												size='lg'
												className={getClassNamesFor('sno')}
												icon='FilterList'
											/>
										</th>
										{columnVisibilityData.map((column: any) => (
											<th
												key={column.keyName}
												scope='col'
												onClick={() => requestSort(column.keyName)}
												className='cursor-pointer text-decoration-underline'>
												{column.columnName}
												<Icon
													size='lg'
													className={getClassNamesFor(column.keyName)}
													icon='FilterList'
												/>
											</th>
										))}
									</tr>
								</thead>
								<tbody>
									{filteredData != '' ? (<>{filteredData.map((rowData: any) => (<tr key={rowData.studentScholarshipDetailsId}><td>{rowData.sno}</td>{columnVisibilityData.map((column: any) =>
										column.isDisplay && rowData[column.keyName] ? (<td key={`${rowData.studentScholarshipDetailsId}-${column.keyName}`}>{rowData[column.keyName]}</td>) : (<td key={`empty-${column.keyName}`} />))}</tr>))}</>) : (
										<NoDataMsg
											columnsCount={columnVisibilityData.length + 2}
											msg={noDataMsg}
										/>
									)}
								</tbody>
							</table>
						</CardBody>
						<PaginationButtons
							className='d-print-none'
							data={items}
							label='items'
							setCurrentPage={setCurrentPage}
							currentPage={currentPage}
							perPage={perPage}
							setPerPage={setPerPage}
						/>
					</Card>
				) : null}
			</Page>
		</PageWrapper>
	);
}
export default StudentScholarshipReport;
